module.exports = __webpack_public_path__ + "img/DSC_0086.87289faf.jpg";